import { createSelector } from 'reselect';
import { ApplicationState } from '../../reducers';
import { BrandCustomField, ItemCustomField } from '../../../types/custom_fields';

const getBrandCustomFields = (state: ApplicationState) => state.brand.customFields.customFields;
const getCustomFields = (state: ApplicationState) => state.items.customFields.customFields;
const getSelectedItemIds = (state: ApplicationState) => state.catalogue.catalogue.selectedItemIds;

const getItemCustomField = (
  selectedItemId: number,
  customFields: ItemCustomField[],
  brandCustomFieldId: number
) => {
  return customFields.find(
    customField =>
      customField.item_id === selectedItemId &&
      customField.brand_custom_field_id === brandCustomFieldId
  );
};

export const mapItemsToCustomFields = createSelector(
  [getBrandCustomFields, getCustomFields, getSelectedItemIds],
  (
    brandCustomFields: BrandCustomField[],
    customFields: ItemCustomField[],
    selectedItemIds: number[]
  ) => {
    return brandCustomFields.map(brandCustomField => {
      const itemCustomField = getItemCustomField(
        selectedItemIds[0],
        customFields,
        Number(brandCustomField.id)
      );
      const value = itemCustomField ? itemCustomField.value : '';
      return {
        id: brandCustomField.id,
        custom_field_type_id: brandCustomField.custom_field_type_id,
        name: brandCustomField.name,
        options: brandCustomField.options,
        headers: brandCustomField.headers,
        table_delimiter: brandCustomField.table_delimiter,
        table_row_delimiter: brandCustomField.table_row_delimiter,
        product_relation_delimiter: brandCustomField.product_relation_delimiter,
        product_relation_brand_code_delimiter:
          brandCustomField.product_relation_brand_code_delimiter,
        script_id: brandCustomField.script_id,
        group_id: brandCustomField.group_id,
        value,
        read_only_custom_field: brandCustomField.read_only_custom_field,
        dynamic_configuration: brandCustomField.dynamic_configuration,
        ai_configuration: brandCustomField.ai_configuration,
        created_at: itemCustomField?.created_at || '',
        updated_at: itemCustomField?.updated_at || '',
      };
    });
  }
);
